export const en = {
  nav: {
    logout: "EXIT SYSTEM",
    profile: "PROFILE",
    labs: "LABORATORIES",
    contact: "CONTACT",
  },
  home: {
    hero_title: "KAI LABORATORY",
    hero_subtext: "Mind behind Code",
    cta: "HACKING LABS DATA",
    featured_title: "DECRYPTED DATA BLOCKS",
    view_all: "VIEW ALL PROTOCOLS",
    access_complete: "ACCESS COMPLETE",
  },
  profile: {
    identity_matrix: "IDENTITY MATRIX",
    agent: "AGENT: KAI",
    status: "STATUS: ONLINE",
    role_label: "ROLE:",
    role_value: "FULL STACK OPERATIVE",
    location_label: "JOB STATUS:",
    location_value: "OPEN TO WORK",
    clearance_label: "RANK:",
    level: "LVL",
    xp: "XP",
    personal_attributes: "PERSONAL ATTRIBUTES",
    physical_attributes: "PHYSICAL ATTRIBUTES",
    psychological_attributes: "MENTAL ATTRIBUTES",
    stats: {
      str: "MUSCLE", str_desc: "Max Force Generation (Gym/Heavy Lifting)",
      vit: "HEALTH", vit_desc: "Health Status (Impacted by Lifestyle)",
      agi: "SPEED", agi_desc: "Work Productivity & Project Speed",
      int: "INTELLIGENCE (IQ)", int_desc: "Continuous Learning & Certifications",
      chr: "EMOTION (EQ)", chr_desc: "Project Management & Social Connections",
      sta: "STAMINA (AQ)", sta_desc: "Work Tenure & Physical Foundation",
    },
    base_stats: "Base Stats",
    breakdown: {
      base_stats: "Base Stats",
      max_health_cap: "Max Health Cap",
      certificates_bonus: "Certificates Bonus",
      projects_bonus: "Completed Projects Bonus",
      management_bonus: "Management Bonus",
      physical_foundation: "Physical Foundation (STR+VIT)"
    },
    history: {
      kai_labs: "KAI Labs / Self-Taught",
      gym: "Gym & Calisthenics",
      community: "Tech Community Lead",
      lifestyle: "Late Night Coding / Overtime"
    },
    actions: {
      add_activity: "QUICK ACTIVITY",
      add_experience: "EXPERIENCE",
      add_project: "PROJECT",
      add_achievement: "ACHIEVEMENT"
    },
    technical_protocols: "TECHNICAL PROTOCOLS",
    achievements_title: "ACHIEVEMENTS",
    validated_achievements: "VALIDATED ACHIEVEMENTS",
    verified: "VERIFIED",
    view_coursera: "VIEW COURSERA PROFILE",
    github_stats: "GITHUB UPLINK",
    certificates: [
      { 
        name: "Search Engine Optimization (SEO) Specialization", 
        organization: "UC Davis", 
        date: "Nov 6, 2025", 
        link: "https://coursera.org/verify/specialization/zitiktgztqd7u", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~ZITIKGTZQD7U.jpeg",
        courses_count: "5 Courses",
        description: "Designed and taught by industry experts. Provides experience, knowledge, and skills for website optimization (On-page & Off-page), smart keyword research, website auditing, and high-quality content development."
      },
      { 
        name: "Google Project Management Professional Certificate", 
        organization: "Google", 
        date: "Nov 30, 2025", 
        link: "https://coursera.org/verify/professional-cert/wo217hz8tjep", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~WO217HZ8TJEP.jpeg",
        courses_count: "7 Courses",
        description: "Completed 7 in-depth courses on project management. Competent in initiating, planning, and running projects using both traditional and Agile methodologies."
      },
      { 
        name: "Generative AI Leader Professional Certificate", 
        organization: "Google Cloud Training", 
        date: "Nov 19, 2025", 
        link: "https://coursera.org/verify/profession-al-cert/enkw129w5m09", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~ENKW129W5M09.jpeg",
        courses_count: "5 Courses",
        description: "For business leaders in the context of Generative AI. Explores key AI/ML concepts, foundation models, deployment strategies, and responsible AI by Google Cloud."
      },
      { 
        name: "HTML, CSS, and Javascript for Web Developers Specialization", 
        organization: "Johns Hopkins University", 
        date: "Nov 22, 2025", 
        link: "https://coursera.org/verify/specialization/zex8jjsgmoe5", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~ZEX8JJSGMOE5.jpeg",
        courses_count: "4 Courses",
        description: "Mastered the basics of Web Coding: HTML, CSS, Responsive Design, and Javascript. Build dynamic web applications with Server-side functionality."
      },
      { 
        name: "Google Prompting Essentials Specialization", 
        organization: "Google", 
        date: "Nov 19, 2025", 
        link: "https://coursera.org/verify/specialization/1282dxyp61a1", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~1282DXYP61A1.jpeg",
        courses_count: "4 Courses",
        description: "Focused on building AI Prompting skills. Competent in designing effective prompts and applying advanced techniques to solve complex tasks, analyze data, and summarize information."
      },
      { 
        name: "Google AI Essentials Specialization", 
        organization: "Google", 
        date: "Sep 30, 2025", 
        link: "https://coursera.org/verify/specialization/2zqo9vs83hxj", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~2ZQO9VS83HXJ.jpeg",
        courses_count: "5 Courses",
        description: "Completed 5 courses on using AI tools responsibly and improving workflow productivity."
      },
      { 
        name: "AI Agent Developer Specialization", 
        organization: "Vanderbilt University", 
        date: "Nov 15, 2025", 
        link: "https://coursera.org/verify/specialization/7txh31k0cq84", 
        image: "/certificates/CERTIFICATE_LANDING_PAGE~7TXH31K0CQ84.jpeg",
        courses_count: "6 Courses",
        description: "Comprehensive program on Agentic AI software development. Designed, built, and deployed AI Agents using Python, Prompt Engineering, and advanced Generative AI."
      }
    ],
  },
  labs: {
    system_tools: "SYSTEM TOOLS",
    frontend: "FRONT END",
    backend: "BACK END",
    database: "DATABASE",
    system_status: "SYSTEM STATUS",
    uptime: "UPTIME:",
    memory: "MEMORY:",
    threat_level: "THREAT LEVEL:",
    threat_low: "LOW",
    title: "LABORATORIES",
    filters: {
      all: "ALL",
      web: "WEB",
      ai: "AI",
      security: "SECURITY",
    }
  },
  contact: {
    title: "INITIATE TRANSMISSION",
    subtitle: "Secure channel established. Enter your credentials.",
    name_label: "ENTER IDENTITY",
    name_placeholder: "Codename or Alias",
    email_label: "ENTER FREQUENCY",
    email_placeholder: "secure@frequency.com",
    message_label: "TRANSMIT MESSAGE",
    message_placeholder: "Enter encrypted data packets...",
    submit_idle: "TRANSMIT SECURELY",
    submit_sending: "TRANSMITTING...",
    submit_sent: "TRANSMISSION COMPLETE",
    access_points: "ENCRYPTED ACCESS POINTS",
    footer_text: "SECURE CONNECTION ESTABLISHED VIA PORT 443.\nENCRYPTION: AES-256-GCM.",
  },
  common: {
    active: "ACTIVE",
    deployed: "DEPLOYED",
    prototype: "PROTOTYPE",
    concept: "CONCEPT",
    open_project: "OPEN PROJECT",
    private_project: "PRIVATE PROJECT",
  }
};
